<template>
  <div style="min-height: 400px">
    <div class="action-cards">
      <card class="quick-actions" title="justopp.userActionsWidget.title">
        <div class="quick-actions__wrapper">
          <saffron-link
            v-for="quickAction in quickActions"
            :key="quickAction.component"
            class="flex c-text plain"
            :to="{ name: quickAction.component }">
            <div class="quick-actions__action flex-middle gap-m">
              <icon-halo
                class="inline-block"
                halo-theme="lead"
                theme="bg"
                :icon="quickAction.icon"
                :size="2"></icon-halo>
              <span class="text-semibold inline-block">{{
                translateUcFirst(quickAction.label)
              }}</span>
            </div>
          </saffron-link>
        </div>
      </card>
      <card title="justopp.dealLogistics.title">
        <div class="flex flex-wrap flex-stretch gap-m">
          <div class="quick-action flex-middle flex-center gap-m">
            <h4>Coming soon...</h4>
          </div>
        </div>
      </card>
      <card class="flex-column" title="justopp.recentOrdersWidget.title">
        <template #body>
          <div class="card__body orders-widget">
            <our-orders />
          </div>
        </template>
      </card>
      <card class="flex-column" title="justopp.recentBidsWidget.title">
        <template #body>
          <div class="card__body bids-widget">
            <our-bids
              :link-to="{ name: 'user-dashboard-bids' }"
              :constant-filters="{
                OwnerId: sg('user.profile')?.id,
              }" />
          </div>
        </template>
      </card>
    </div>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import OurOrders from "@/client/applications/justopp/components/widgets/OurOrders.vue";
import OurBids from "@/client/applications/justopp/components/widgets/OurBids.vue";
import { mapState } from "vuex";

export default {
  components: {
    OurOrders,
    OurBids,
  },
  layout: {
    component: "UserDashboardInner",
    params: {
      title: "justopp.userDashboard.pageTitle",
      subTitle: "justopp.userDashboard.pageSubtitle",
    },
  },
  middleware: {
    requireUser: {},
    requireNotVendor: {},
  },
  props: {},
  setup() {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();

    const quickActions = [
      {
        component: "user-dashboard-profile",
        label: "justopp.userActionsWidget.actions.personalProfile",
        icon: "user",
      },
      {
        component: "user-dashboard-profile-company",
        label: "justopp.userActionsWidget.actions.companyProfile",
        icon: "bag-plus",
      },
      {
        component: "user-dashboard-chats",
        label: "justopp.userActionsWidget.actions.chats",
        icon: "chat",
      },
      {
        component: "user-dashboard-orders",
        label: "justopp.userActionsWidget.actions.orders",
        icon: "cart",
      },
      {
        component: "user-dashboard-bids",
        label: "justopp.userActionsWidget.actions.bids",
        icon: "lightbulb",
      },
    ];

    return { asyncOps, asyncOpsReady, asyncStatus, quickActions };
  },
  meta: "justopp.userDashboard.browserTitle",
  data() {
    return {
      asyncData: {},
    };
  },
  computed: {
    ...mapState(["user"]),
    userId() {
      return this.user.user.id;
    },
  },
  watch: {},
  methods: {
    logout() {
      this.$store.commit("user/logout");
      this.$router.push({ path: "/" });
    },
  },
};
</script>

<style lang="scss" scoped>
.action-cards {
  display: flex;
  flex-wrap: wrap;
  gap: var(--margin-2xl);
  flex-wrap: wrap;

  > * {
    flex: 0 0 calc(50% - var(--margin-2xl) / 2);
    @media (max-width: 1024px) {
      flex: 0 0 100%;
    }
  }
}

.quick-actions {
  &__wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    row-gap: var(--margin-l);
    column-gap: var(--margin-m);

    @media (max-width: 600px) {
      grid-template-columns: 1fr;
    }
  }
}

.bids-widget,
.orders-widget {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;

  & > :deep(.content) {
    flex: 1 1 auto;

    .item-table-wrapper {
      display: flex;
      flex-direction: column;
      height: 100%;

      & > .skeleton-content {
        flex: 0 1 auto;
      }

      & > :not(.skeleton-content) {
        flex: 1 1 auto;

        table {
          height: 100%;
        }
      }
    }
  }

  & > :deep(.see-all) {
    flex: 0 1 auto;
  }

  :deep(.overflow-x-scroll) {
    overflow-x: auto !important;
  }
}

:deep(td span) {
  min-width: 0px !important;
}
</style>
